import type { ApiDimensions } from '../../../api/types';

export type DiagramLayout = 'normal' | 'wide' | 'tall';

export const WIDE_DIAGRAM_RATIO = 3.2;
export const TALL_DIAGRAM_RATIO = 2.4;

export function getDiagramLayout(width: number, height: number): DiagramLayout {
  if (!width || !height) {
    return 'normal';
  }

  const aspectRatio = width / height;
  if (aspectRatio >= WIDE_DIAGRAM_RATIO) {
    return 'wide';
  }
  if ((height / width) >= TALL_DIAGRAM_RATIO) {
    return 'tall';
  }

  return 'normal';
}

export function calculateMermaidViewerImageSize(
  dimensions: ApiDimensions,
  viewport: ApiDimensions,
): ApiDimensions {
  const layout = getDiagramLayout(dimensions.width, dimensions.height);
  if (layout !== 'normal') {
    return dimensions;
  }

  const aspectRatio = dimensions.height / dimensions.width;
  const calculatedWidth = Math.min(dimensions.width, viewport.width);
  const calculatedHeight = Math.round(calculatedWidth * aspectRatio);

  if (calculatedHeight > viewport.height) {
    return {
      width: Math.round(viewport.height / aspectRatio),
      height: viewport.height,
    };
  }

  return {
    width: calculatedWidth,
    height: Math.round(calculatedWidth * aspectRatio),
  };
}
